export default __webpack_public_path__ + "static/media/texp6.5fd4443c.png";